import {Component, ElementRef, EventEmitter, HostBinding, Input, Output, ViewChild} from '@angular/core';
import { AnimationController } from '@ionic/angular';

@Component({
  selector: 'coll-panel',
  templateUrl: 'coll-panel.html',
  styleUrls: ['coll-panel.scss'],
})
export class CollPanelComponent {

  @HostBinding("style.--acc-height")
  public accHeight: string = '0.1px';

  @ViewChild('bodyWrapper', { read: ElementRef }) private body: ElementRef;
  @ViewChild('container', { read: ElementRef }) private container: ElementRef;

  @Input() public id: string;
  @Input() public type: string ='v';

  private _expanded: boolean = false;

  private _collapsMarker: Dictionary<boolean>;

  @Output() public headClicked: EventEmitter<string> = new EventEmitter<string>();          
  @Output() public bodyClicked: EventEmitter<string> = new EventEmitter<string>();          

  constructor(
    private animationCtrl: AnimationController,
  ) { }

  @Input() public set expanded(expanded: boolean) {
    console.log("setexp: "+ expanded);
    if ( this._expanded != expanded ) {
      this.accHeight = this.container.nativeElement.offsetHeight + "px";
      setTimeout(() => { this._expanded = expanded });
    }
  }

  public get expanded(): boolean {
    return this._expanded;
  }

  @Input() public set collapsMarker(collapsMarker: Dictionary<boolean>) {
    this._collapsMarker = collapsMarker;
    if (this._collapsMarker[this.id] !== undefined) {
      this._expanded = this._collapsMarker[this.id];
    }
    //this.accHeight = this.container.nativeElement.offsetHeight + "px";
    //console.log("acc: "+this.accHeight);
  };  

  public clickHead(event: Event): void {
    event.preventDefault();
    event.stopImmediatePropagation();
    console.log(this.headClicked);
    if (this.headClicked.observed) {
      this.headClicked.emit(this.id);
    }
    else {
      this.clickIcon(event);
    }
  }

  public clickBody(event: Event): void {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (this.bodyClicked !== null) {
      this.bodyClicked.emit(this.id);
    }
  }

  public clickIcon(event: Event): void {
    event.preventDefault();
    event.stopImmediatePropagation();
    this._expanded = !this._expanded;
    this.accHeight = this.container.nativeElement.offsetHeight + "px";
    if (this._collapsMarker !== undefined && this.id !== undefined) {
      this._collapsMarker[this.id] = this._expanded;
    }
  }

}
